<template>
  <div class="tgb-field mb-3 w-full" :class="rootClass">
    <label v-if="label" :class="labelClass" class="tgb-field__label mb-2 block">
      {{ label }}
    </label>
    <div class="tgb-field__body relative">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Field',
  props: {
    label: String,
    labelClass: String,
    rootClass: String,
  },
};
</script>
